export const asnStates = {
  PENDIENTE: 'Pendiente',
  RECEPCIONADA: 'Recepcionada',
  FINALIZADA: 'Finalizada',
  ANULADA: 'Anulada',
  ELIMINADA: 'Eliminada',
  // ESTADOS STORAGE EXTERNO
  FINALIZADA_COMPLETA_ES: 'Finalizada Completa AE',
  FINALIZADA_INCOMPLETA_ES: 'Finalizada Incompleta AE'
}
